import React from 'react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import TopbarProfile from './TopbarProfile';
import TopBarNotification from './TopBarNotification';
import SearchBar from '../searchbar/Searchbar';
import TopBarMenuItem from './TopBarMenuItem';
import TopbarSupport from './TopbarSupport';
import TopbarHelp from './TopbarHelp';

interface Props {
  isAuth: boolean;
}

const Topbar: React.FC<Props> = ({ isAuth }) => {
  const { t } = useTranslation();
  const icon = `${process.env.PUBLIC_URL}/img/burger.svg`;

  const logo = <Link className="topbar__logo" to="/" />;

  if (!isAuth) {
    return (
      <div className="topbar">
        <div className="topbar__wrapper">
          <div className="topbar__left">{logo}</div>
        </div>
      </div>
    );
  }

  const subItemsMobile = () => {
    const items = [
      { text: t('home'), to: '/' },
      { text: t('operations'), to: '/Operations' },
      { text: t('missions'), to: '/missions' },
      { text: t('IDB Grievance Protocol'), to: '/grievance-protocol' },
      { text: t('miciCases'), to: '/mici-cases' },
      { text: t('E&S Insights'), to: '/report-es-insight' },
      { text: t('E&S Grievance Insights'), to: '/report-es-grievance-insight' },
    ];

    return items;
  };

  return (
    <div className="topbar topbar--navigation">
      <div className="topbar__wrapper">
        <div className="topbar__left">
          {logo}
          <SearchBar />
        </div>

        <div className="topbar__right">
          <div className="topbar__nav">
            <TopBarMenuItem text={t('home')} to="/" />
            <TopBarMenuItem text={t('operations')} to="/operations" />
            <TopBarMenuItem text={t('missions')} to="/missions" />

            <TopBarMenuItem
              text={t('Mechanisms')}
              className="topbar-mechanisms"
              subItems={[
                { text: t('IDB Grievance Protocol'), to: '/grievance-protocol' },
                { text: t('miciCases'), to: '/mici-cases' },
              ]}
            />

            <TopBarMenuItem
              text={t('Dashboards')}
              className="topbar-small"
              subItems={[
                { text: t('E&S Insights'), to: '/report-es-insight' },
                { text: t('E&S Grievance Insights'), to: '/report-es-grievance-insight' },
              ]}
            />
          </div>
          <div className="topbar__actions">
            <div className="topbar__divider" />
            <TopBarNotification />

            <div className="topbar__divider" />
            <TopbarSupport />

            <div className="topbar__divider" />
            <TopbarHelp />

            <div className="topbar__divider" />
            <TopbarProfile />

            <TopBarMenuItem
              text={<img src={icon} alt="" className="topbar__button-icon" />}
              subItems={subItemsMobile()}
              className="only-mobile"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Topbar, (prevProps, nextProps) => prevProps.isAuth === nextProps.isAuth);
